import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from './AuthContextProvider';
import * as Constants from './Constants';
import { FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';
import ErrorDialog from './ErrorDialog';

const Home = () => {
  const { user, setCaringFor } = useContext(AuthContext);
  const [ cfor, setCFor] = useState(user.caringFor);
  
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);

  useEffect(() => {
    if (user.caringFor && user._careGiverFor?.length) {
      const match = user._careGiverFor.find(u => u._id === user.caringFor._id);
      if (match) setCFor(match);
    }
  }, [user]);

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  const onChange = (event) => {
    setCaringFor(user, event.target.value);
    setCFor(event.target.value);
  };

  const getCaringFor = () => {
    if (user.loginRole === Constants.ROLE_FAMILY_MEMBER) {
      if (user._careGiverFor.length === 0) {
        setErrorMessage("You are not currently caring for anyone.");
        setOpenErrorDialog(true);
        return null;
      }
      if (!user.caringFor) {
        setCaringFor(user, user._careGiverFor[0]);
        user.caringFor = user._careGiverFor[0];
        setCFor(user._careGiverFor[0]);
      }
      if (user._careGiverFor.length > 1) {
        return (
          <FormControl className="Select" sx={{marginTop: "1em", width: 600}}>
            <InputLabel className="Select" id="repeat-label">Caring For</InputLabel>
            <Select
              className="Select"
              labelId="repeat-label"
              id="repeat"
              value={cfor}
              label="Caring For"
              onChange={onChange}
            >
              {user._careGiverFor.map((cguser, index) => (
                <MenuItem key={index} value={cguser}>{`${cguser.first} ${cguser.last}`}</MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  return (
    <div className="Home">
      <Typography variant="h6" gutterBottom>
        Welcome {user.first} {user.last} as {user.loginRole} 
        {user.caringFor ? ` caring for ${user.caringFor.first} ${user.caringFor.last}` : '' }
      </Typography>
      {getCaringFor()}
      <img src="/televisit_logo.png" alt="Televisit Logo"
        style={{ cursor: 'pointer', width: '200px', height: '200px' }} 
      />
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default Home;
